export default "__VITE_ASSET__BD04DBaz__"